<template>
  <div class="login">
    <q-progress indeterminate stripe animate color="teal-2"  v-if="isProgress" />
    <img v-if="loginImgNum == 0 "src="../assets/u-pin.png" alt="red-u-pin">
    <img v-else-if="loginImgNum == 1 "src="../assets/u-so.png" alt="red-u-so">
    <img v-else src="../assets/u-man.png" alt="red-u-man">
    <div style="padding-bottom: 20px;">
      <q-btn class="login_btn" icon="" v-on:click="signup()" color="secondary" label="Sign in by Google" :disable="isProgress" /></q-btn>
    </div>
      <q-btn flat dense label="Use without login"  @click="signupByAnonymous" color="primary" />
  </div>
</template>

<script>
import firebase from 'firebase'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      isProgress: true
    }
  },
  created () {
    this.checkParameter()
    this.checkLogin()
  },
  computed: {
    loginImgNum () {
      const items = ['u-pin', 'u-so', 'u-man']
      // 最大値は配列の「要素数」にする
      const random = Math.floor(Math.random() * items.length)
      return random
    },
    ...mapGetters('UserInfo', {
      shareScoreID: 'getShareScoreID',
      myUID: 'getMyUID'
    })
  },
  methods: {
    ...mapActions('ScoreTable', {
      setScoreIDToUserDB: 'setScoreIDToUserDB'
    }),
    ...mapMutations('UserInfo', {
      setShareScoreID: 'setShareScoreID',
      setMyUID: 'setMyUID'
    }),
    ...mapGetters('UserInfo', {
      getShareScoreID: 'getShareScoreID'
    }),
    checkParameter () {
      const scoreID = this.$route.query.share_score_id
      if (!scoreID) {
        return
      }
      this.setShareScoreID(scoreID)
    },
    checkLogin () {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          // ログイン済みの場合はScoreへ飛ばす
          this.setMyUID(user.uid)
          this.goScorePage()
        }
        this.isProgress = false
      })
    },
    signupByAnonymous () {
      this.isProgress = true
      firebase.auth().signInAnonymously().catch(function (error) {
        console.log(error.code)
        console.log(error.message)
        alert('匿名ログインに失敗しました')
        this.isProgress = false
      })
    },
    signup () {
      this.isProgress = true
      let provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider).then(
        result => {
          this.setUserInfo(result)
          this.goScorePage()
        },
        error => {
          alert('ログインに失敗しました')
          console.log(error)
          this.isProgress = false
        }
      )
    },
    goScorePage () {
      if (this.shareScoreID) {
        const sID = this.shareScoreID
        this.setScoreIDToUserDB({scoreID: sID, uid: this.myUID, timestamp: firebase.firestore.FieldValue.serverTimestamp()})
        this.$router.push({ name: 'Score', params: {id: sID} })
        return
      }
      this.$router.push({ name: 'NewScore' })
    },
    setUserInfo (result) {
      const db = firebase.firestore()
      db.collection('Users').doc(result.user.uid).set({
        name: result.user.displayName
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .login_btn{
        display:block;
        margin: 1rem auto 0 auto;
        height: 3rem;
        width: 80%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue